/**
 * SeasonalAnt – die 🐜 mit saisonalem Hut (Kürbis, Weihnachtsmütze, Partyhut, Blüten, Herbstblatt).
 * Ohne aktive Saison bleibt es die normale Ameise.
 */
import { Component, Show, Switch, Match } from 'solid-js';
import { useSeason } from '../utils/seasonal';

const SantaHat = () => (
  <svg viewBox="0 0 32 28" width="1em" height="0.875em" aria-hidden="true">
    <path d="M3 21 C6 8 16 2 27 6 C24 10 22 15 21 21 Z" fill="#dc2626" />
    <path d="M3 21 C6 8 16 2 27 6" fill="none" stroke="#991b1b" stroke-width="0.8" />
    <rect x="1.5" y="19.5" width="21" height="5" rx="2.5" fill="#fff" />
    <circle cx="27.5" cy="6" r="3.2" fill="#fff" />
  </svg>
);
const PartyHat = () => (
  <svg viewBox="0 0 28 30" width="0.9em" height="0.96em" aria-hidden="true">
    <path d="M14 3 L25 27 H3 Z" fill="#a855f7" />
    <path d="M14 3 L19.5 15 H8.5 Z" fill="#f472b6" />
    <path d="M7 20 H21 L22.5 24 H5.5 Z" fill="#fbbf24" />
    <circle cx="14" cy="3" r="2.6" fill="#fde047" />
  </svg>
);

/** Nur der Hut – z. B. über Avatare auf dem Siegerpodest */
export const SeasonalHat: Component<{ class?: string }> = (props) => {
  const { season } = useSeason();
  return (
    <Show when={season()}>
      <span class={`season-hat season-hat--${season()!.name} ${props.class || ''}`} aria-hidden="true">
        <Switch>
          <Match when={season()!.name === 'snow'}><SantaHat /></Match>
          <Match when={season()!.name === 'fireworks'}><PartyHat /></Match>
          <Match when={season()!.name === 'sparks'}>🎃</Match>
          <Match when={season()!.name === 'blossom'}>🌸</Match>
          <Match when={season()!.name === 'leaves'}>🍁</Match>
        </Switch>
      </span>
    </Show>
  );
};

const SeasonalAnt: Component<{ class?: string }> = (props) => {
  const { season } = useSeason();
  return (
    <span class={`season-ant ${props.class || ''}`}>
      <span class="season-ant-body">🐜</span>
      <Show when={season()}>
        <span class={`season-hat season-hat--${season()!.name}`} aria-hidden="true">
          <Switch>
            <Match when={season()!.name === 'snow'}><SantaHat /></Match>
            <Match when={season()!.name === 'fireworks'}><PartyHat /></Match>
            <Match when={season()!.name === 'sparks'}>🎃</Match>
            <Match when={season()!.name === 'blossom'}>🌸</Match>
            <Match when={season()!.name === 'leaves'}>🍁</Match>
          </Switch>
        </span>
      </Show>
    </span>
  );
};

export default SeasonalAnt;
